/* eslint-disable react/jsx-filename-extension, react/jsx-props-no-spreading */

import React, { Component } from 'react';
import {
  getLiveAlertsForSite,
  sortLiveAlertsBySeverity,
  filterLiveAlertsBySupportedTypes,
} from 'services/weatherService';
import WeatherAlertDetail from './WeatherAlertDetail';

class WeatherAlertsDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alertData: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    getLiveAlertsForSite().then((alertData) => {
      const filteredAlertData = filterLiveAlertsBySupportedTypes(alertData);
      const sortedAlertData = sortLiveAlertsBySeverity(filteredAlertData);
      this.setState({
        alertData: sortedAlertData,
        isLoading: false,
      });
    });
  }

  render() {
    const { alertData, isLoading } = this.state;
    const {
      loading_alerts: loadingText,
      no_current_alerts: noAlertsText,
    } = window.nexstar.weather_alerts.l10n;

    if (isLoading) {
      return (
        <p>
          <strong>
            {loadingText}
            {' '}
            &hellip;
          </strong>
        </p>
      );
    }

    if (! alertData.length) {
      return (
        <p>
          <strong>{noAlertsText}</strong>
        </p>
      );
    }

    return (
      <>
        <div>
          {alertData.map((alert) => (
            <WeatherAlertDetail
              key={alert.alertKey}
              severity={alert.severity}
              {...alert.weatherDetail}
            />
          ))}
        </div>
      </>
    );
  }
}

export default WeatherAlertsDetail;
